import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { INewsArticle } from '../../models/resource';

export interface NewsApiResponse {
  Id: number;
  Title: string;
  Content: string;
  ImageUrl: string;
  Url: string;
  Date: string;
}

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  private readonly apiUrl = `${environment.apiBaseUrl}/umbraco/api/LatestNewsApi/GetLatestNewsItems`;

  constructor(private readonly http: HttpClient) { }

  getLatestNews(): Observable<INewsArticle[]> {
    return this.http.get<NewsApiResponse[]>(this.apiUrl).pipe(
      map(newsItems => newsItems.map(this.mapToNewsArticle.bind(this)))
    );
  }

  private mapToNewsArticle(apiResponse: NewsApiResponse): INewsArticle {
    // We use /image here to route correctly throught the gateway
    return {
      id: apiResponse.Id.toString(),
      title: apiResponse.Title,
      content: apiResponse.Content,
      publishedDate: new Date(apiResponse.Date),
      imageUrl: `${environment.apiBaseUrl}/image` + apiResponse.ImageUrl,
      linkUrl: 'https://www.curro.co.za' + apiResponse.Url
    };
  }
}
